const UNSUPPORTED_MARKDOWN_PATTERNS = [
  /^>\s/m, // blockquote
  /\[([^\]]*)\]\([^)]*\)/, // markdown link
  /^\|[^\n]+\|/m, // table row
  /^\|?[\s:|-]+\|/m, // table separator row
  /(?<!`)`([^`\n]+)`(?!`)/, // inline code
  /```/, // fenced code block
];

/**
 * Teams Adaptive Cards do not support:
 * - Blockquotes (> )
 * - Links ([text](url))
 * - Tables (| col | col |)
 * - Inline code (`code`)
 */
export const hasUnsupportedTeamsMarkdown = (markdown) => {
  if (!markdown || typeof markdown !== "string") {
    return false;
  }

  const normalized = markdown.replace(/<!--[\s\S]*?-->/g, "");

  return UNSUPPORTED_MARKDOWN_PATTERNS.some((pattern) =>
    pattern.test(normalized)
  );
};
